module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f9de-200d-2642-fe0f.a08f3a02.svg";